module.exports = __webpack_public_path__ + "static/media/Inter-Medium.900f3102.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Inter/Inter-Medium.woff2
// module id = 698
// module chunks = 21